<template>
  <div class="grid grid-cols-3 gap-4">
    <div
      class
      @click="$parent.$refs.imageLightbox.open(block.form.image_1.id)"
      v-if="mediaIds[block.form.image_1.id]"
    >
      <img
        :src="mediaIds[block.form.image_1.id].large"
        alt
        class="h-48 w-full object-cover cursor-pointer"
      />
      <div
        v-if="block.form.caption_1"
        class="text-center text-gray-600 mt-2 text-sm"
      >{{ block.form.caption_1 }}</div>
    </div>
    <div
      class
      @click="$parent.$refs.imageLightbox.open(block.form.image_2.id)"
      v-if="mediaIds[block.form.image_2.id]"
    >
      <img
        :src="mediaIds[block.form.image_2.id].large"
        alt
        class="h-48 w-full object-cover cursor-pointer"
      />
      <div
        v-if="block.form.caption_2"
        class="text-center text-gray-600 mt-2 text-sm"
      >{{ block.form.caption_2 }}</div>
    </div>
    <div
      class
      @click="$parent.$refs.imageLightbox.open(block.form.image_3.id)"
      v-if="mediaIds[block.form.image_3.id]"
    >
      <img
        :src="mediaIds[block.form.image_3.id].large"
        alt
        class="h-48 w-full object-cover cursor-pointer"
      />
      <div
        v-if="block.form.caption_3"
        class="text-center text-gray-600 mt-2 text-sm"
      >{{ block.form.caption_3 }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    block: {},
    mediaIds: {}
  },
  created() {
    // Add all images to the lightbox list
    this.$nextTick(() => {
      if (this.mediaIds[this.block.form.image_1.id]) {
        this.$parent.$refs.imageLightbox.images.push({
          id: this.block.form.image_1.id,
          url: this.mediaIds[this.block.form.image_1.id].large,
          caption: this.block.form.caption_1
        });
      }
      if (this.mediaIds[this.block.form.image_2.id]) {
        this.$parent.$refs.imageLightbox.images.push({
          id: this.block.form.image_2.id,
          url: this.mediaIds[this.block.form.image_2.id].large,
          caption: this.block.form.caption_2
        });
      }
      if (this.mediaIds[this.block.form.image_3.id]) {
        this.$parent.$refs.imageLightbox.images.push({
          id: this.block.form.image_3.id,
          url: this.mediaIds[this.block.form.image_3.id].large,
          caption: this.block.form.caption_3
        });
      }
    });
  }
};
</script>

<style lang="scss" scoped></style>
